var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: {
      id: _vm.id,
      modalClass: "modal-md",
      headerText: _vm.headerText,
      showCloseButton: false
    },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function() {
          return [
            _c("div", { staticClass: "container-footer" }, [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { type: "button" },
                    on: { click: _vm.onClickClose }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("button.close")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79a8b5a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a8b5a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseAlertModal.vue
// module id = null
// module chunks = 